const cookieStorage = {
	getItem: (item) => {
		const cookies = document.cookie
			.split(';')
			.map((cookie) => cookie.split('='))
			.reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
		return cookies[item];
	},
	setItem: (item, value, days) => {
		// document.cookie = `${item}={value: ${value}};`;

		const d = new Date();
		d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
		let expires = 'expires=' + d.toUTCString();
		document.cookie = item + '=' + value + ';' + expires + ';path=/';
	},
};

// Base Cookie Storage
const storageType = cookieStorage;

// General Cookie Popup
const consentPropertyName = 'SC_CookieConsent';
const promptConsent = () => !storageType.getItem(consentPropertyName);
const saveToStorage = () => storageType.setItem(consentPropertyName, true, 365);
const declineCookieStorage = () =>
	storageType.setItem(consentPropertyName, false);

window.onload = () => {
	// ********************************************
	// Cookie Storage Function
	// ********************************************

	const acceptFn = () => {
		saveToStorage(storageType);
		consentPopup.classList.add('hidden');
	};

	const declineFn = () => {
		declineCookieStorage(storageType);
		consentPopup.classList.add('hidden');
	};

	const consentPopup = document.getElementById('consent-popup');
	const acceptBtn = document.getElementById('accept');
	const declineBtn = document.querySelector('.close-consent');
	acceptBtn.addEventListener('click', (e) => {
		e.preventDefault();
		acceptFn();
	});

	declineBtn.addEventListener('click', (e) => {
		e.preventDefault();
		declineFn();
	});

	if (promptConsent(storageType)) {
		setTimeout(() => {
			consentPopup.classList.remove('hidden');
		}, 300);
	}

	// If cookie is accepted
	if (storageType.getItem(consentPropertyName) == 'true') {
		// DO something
	}
};
